import NeatPopup from "components/device/neat/neatPopup";
import React from "react";
import { useDispatch } from "react-redux";
import { openPopup } from "redux/slices/drawerPopupSlice";

function NeatMain() {
  //dispatch
  const dispatch = useDispatch();

  const showDrawer = (menu) => {
    dispatch(
      openPopup({
        type: menu,
      })
    );
    document.querySelector("#page_header").style.height = "0";
  };

  return (
    <>
      <div>NeatMain</div>
      <div>
        <button onClick={() => showDrawer("bar")}>Neat Bar Detail Open</button>
        <button onClick={() => showDrawer("bar2")}>
          Neat Bar2 Detail Open
        </button>
        <button onClick={() => showDrawer("barpro")}>
          Neat Bar Pro Detail Open
        </button>
        <button onClick={() => showDrawer("board50")}>
          Neat Board 50 Detail Open
        </button>
        <button onClick={() => showDrawer("boardpro")}>
          Neat Board Pro Detail Open
        </button>
        <button onClick={() => showDrawer("frame")}>
          Neat Frame Detail Open
        </button>
        <button onClick={() => showDrawer("center")}>
          Neat Center Detail Open
        </button>
        <button onClick={() => showDrawer("pad")}>Neat Pad Detail Open</button>
      </div>

      <NeatPopup />
    </>
  );
}

export default NeatMain;
